module.exports = __webpack_public_path__ + "static/media/19.23e8ebf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/19.jpg
// module id = 280
// module chunks = 0